import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { Frame as n } from "../Frame/Frame.js";
import { cx as p } from "../apps/ui/styled-system/css/cx.js";
import { css as o } from "../apps/ui/styled-system/css/css.js";
function v({
  label: a,
  className: l,
  position: s = "start",
  size: r,
  spacing: c,
  ...i
}) {
  const e = n.useFrame(!0), m = (e == null ? void 0 : e.mode) ?? "dialog";
  return r ?? (r = m === "dialog" ? "small" : "medium"), /* @__PURE__ */ d(
    "div",
    {
      className: p(
        o({
          alignItems: "center",
          color: "var(--text-color-th_base-secondary)",
          display: "flex",
          letterSpacing: -0.5,
          userSelect: "none",
          whiteSpace: "nowrap",
          width: "100%"
        }),
        r === "small" && o({
          fontSize: 12,
          gap: 8
        }),
        r === "medium" && o({
          fontSize: 14,
          gap: 12
        }),
        l
      ),
      style: {
        paddingBlock: c ?? (r === "small" ? 8 : 16)
      },
      ...i,
      children: [
        s === "center" && /* @__PURE__ */ t(
          "div",
          {
            className: o({
              backgroundColor: "var(--color-th_separator)",
              height: 1,
              width: "100%"
            })
          }
        ),
        a,
        /* @__PURE__ */ t(
          "div",
          {
            className: o({
              backgroundColor: "var(--color-th_separator)",
              height: 1,
              width: "100%"
            })
          }
        )
      ]
    }
  );
}
export {
  v as Separator
};
//# sourceMappingURL=Separator.js.map
